import { Image, SimpleGrid, Stack, Text } from '@mantine/core';
import { stickers } from './sticker';
export const StickerList: React.FC = () => {
  return <Stack gap={24}>
      {stickers.map(item => <Stack key={item.title} gap={12}>
          <Text fz="xs" fw={700} c="var(--text-dark)" tt="uppercase">
            {item.title}
          </Text>
          <SimpleGrid cols={5} spacing="sm">
            {item.items.map(sticker => <Image key={sticker} src={sticker} alt="sticker" w={36} h={36} />)}
          </SimpleGrid>
        </Stack>)}
    </Stack>;
};